import React, { useRef, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useGetNftBalanceQuery } from "../../app/features/apiSlice";
import Loader from "../Loader";
import Error from "../Error";
import { useParams } from "react-router";
import TransferNFT from "./TransferNFT";
import TransferNftButton from "./TransferNftButton";

const NFTBalance = () => {
  const { t } = useTranslation();
  const { lang } = useParams();
  const [identitySession, setIdentitySession] = useState();
  const sessionId = useRef(Date.now()).current;

  const { data, isLoading, isError, error, refetch } = useGetNftBalanceQuery({
    sessionId,
    lang,
  });

  if (isLoading) return <Loader />;
  if (isError) return <Error error={error} />;

  return (
    <Card bg="dark1 text-light mb-2">
      <Card.Header>
        <p className="mb-0">GT Token</p>
      </Card.Header>
      <Card.Body>
        <Row>
          {data?.message && <p className="p-2">{data.message}</p>}

          {data?.length > 0 && (
            <>
              <TransferNftButton
                setIdentitySession={setIdentitySession}
                identitySession={identitySession}
              />
              {data.map((nft) => (
                <Col md="3" className="mb-3" key={nft.asset_id}>
                  <Card className="h-100">
                    {/* NFT Image */}
                    <Card.Img
                      variant="top"
                      src={nft.mutable_data.image_url[0]}
                      alt="NFT Image"
                      style={{
                        height: "175px",
                        objectFit: "fill",
                        width: "100%",
                      }}
                    />

                    <Card.Body className="d-flex flex-column">
                      {/* NFT Details */}
                      <Card.Title className="small mb-1 mt-2">
                        <b>{t("weight")}:</b> {nft.mutable_data.weight}
                      </Card.Title>

                      <Card.Title className="small mb-1 mt-2">
                        <b>{t("assetId")}:</b> {nft.asset_id}
                      </Card.Title>

                      <Card.Text className="small mb-0">
                        <b>{t("eosAccountName")}:</b> {nft.eosAccountName}
                      </Card.Text>

                      <Card.Text className="small mb-2">
                        <b>{t("transactionId")}:</b>{" "}
                        {nft.transactionId && (
                          <a
                            href={`${process.env.REACT_APP_EOS_URL}/${nft.transactionId}?network=${process.env.REACT_APP_EOS_NETWORK}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {nft.transactionId}
                          </a>
                        )}
                      </Card.Text>

                      {identitySession && (
                        <TransferNFT
                          identitySession={identitySession}
                          nft={nft}
                          refetch={refetch}
                        />
                      )}
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </>
          )}
        </Row>
      </Card.Body>
    </Card>
  );
};

export default NFTBalance;
